import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const DocumentCard = ({ document }) => {
  const statusConfig = {
    verified: {
      color: 'text-success',
      bgColor: 'bg-success/10',
      icon: 'CheckCircle',
      label: 'Verified',
    },
    pending: {
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      icon: 'Clock',
      label: 'Pending Review',
    },
    rejected: {
      color: 'text-destructive',
      bgColor: 'bg-destructive/10',
      icon: 'XCircle',
      label: 'Rejected',
    },
    missing: {
      color: 'text-muted-foreground',
      bgColor: 'bg-muted',
      icon: 'AlertCircle',
      label: 'Not Uploaded',
    },
  };

  const status = statusConfig?.[document?.status] || statusConfig?.missing;

  const getFileIcon = (type) => {
    const iconMap = {
      pdf: 'FileText',
      image: 'Image',
      doc: 'FileText',
      default: 'File',
    };
    return iconMap?.[type] || iconMap?.default;
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 hover:shadow-warm transition-smooth">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 md:w-12 md:h-12 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0">
          <Icon
            name={getFileIcon(document?.fileType)}
            size={20}
            color="var(--color-primary)"
          />
        </div>

        <div className="flex-1 min-w-0">
          <h4 className="text-sm md:text-base font-medium text-foreground mb-1 truncate">
            {document?.name}
          </h4>

          <div className="flex flex-wrap items-center gap-2 mb-2">
            <div className={`${status?.bgColor} px-2 py-1 rounded flex items-center gap-1`}>
              <Icon name={status?.icon} size={14} color={`var(--color-${document?.status === 'verified' ? 'success' : document?.status === 'pending' ? 'warning' : document?.status === 'rejected' ? 'destructive' : 'muted-foreground'})`} />
              <span className={`text-xs font-medium font-caption ${status?.color}`}>
                {status?.label}
              </span>
            </div>

            {document?.uploadDate && (
              <span className="text-xs text-muted-foreground font-caption">
                {document?.uploadDate}
              </span>
            )}
          </div>

          {document?.fileSize && (
            <p className="text-xs text-muted-foreground font-caption mb-3">
              {document?.fileSize}
            </p>
          )}

          <div className="flex flex-wrap gap-2">
            {document?.status === 'missing' ? (
              <Button variant="default" size="sm" iconName="Upload" iconPosition="left">
                Upload
              </Button>
            ) : (
              <>
                <Button variant="outline" size="sm" iconName="Eye" iconPosition="left">
                  View
                </Button>
                <Button variant="ghost" size="sm" iconName="Download" iconPosition="left">
                  Download
                </Button>
                {document?.status !== 'verified' && (
                  <Button variant="ghost" size="sm" iconName="RefreshCw" iconPosition="left">
                    Replace
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DocumentCard;